import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=849acec4&scoped=true"
import script from "./leader.vue?vue&type=script&lang=js"
export * from "./leader.vue?vue&type=script&lang=js"
import style0 from "./leader.vue?vue&type=style&index=0&id=849acec4&prod&scoped=true&lang=css"
import style1 from "./leader.vue?vue&type=style&index=1&id=849acec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849acec4",
  null
  
)

export default component.exports